import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'dateDescription' })
export class RelativeDatePipe implements PipeTransform {
  transform(value: Date): any {
    return moment(value).fromNow();
  }
}
